import axios from 'axios'

export const state = {
  purposes: null,
}

export const getters = {
  purposes: (state) => state.purposes,
  purposeOptions: (state) =>
    state.purposes &&
    state.purposes.map(({ title }) => ({ id: title, label: title })),
}

export const mutations = {
  SET_PURPOSES(state, purposes) {
    state.purposes = purposes
  },
}

export const actions = {
  fetchAllPurposes({ commit, state, rootState }) {
    return axios.get('/api/purposes').then((response) => {
      const purposes = response.data
      commit('SET_PURPOSES', purposes)
      return purposes
    })
  },
}
